import { render, staticRenderFns } from "./card-badge-rivoneed.vue?vue&type=template&id=4bfe0771&scoped=true&"
import script from "./card-badge-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-badge-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-badge-rivoneed.vue?vue&type=style&index=0&id=4bfe0771&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe0771",
  null
  
)

export default component.exports